import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import CompanyMenu from './CompanyMenu';

interface CompanyHeaderProps {
  isCollapsed: boolean;
  setActiveSection: (section: string) => void;
  logoUrl: string | null;
  organizationName: string;
}

const CompanyHeader: React.FC<CompanyHeaderProps> = ({ isCollapsed, setActiveSection, logoUrl, organizationName }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      <div 
        className={`flex items-center ${isCollapsed ? 'justify-center' : 'gap-3'} mb-1 cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-all duration-150 ease-in-out`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <div className={`w-10 h-10 rounded-full overflow-hidden border-2 border-gray-100 flex-shrink-0 ${
          isCollapsed ? 'scale-75' : ''
        } transition-transform duration-150 bg-gray-50 flex items-center justify-center`}>
          {logoUrl ? (
            <img
              src={logoUrl}
              alt="Company Logo"
              className="w-full h-full object-contain"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-400">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
          )}
        </div>
        <div className={isCollapsed ? 'hidden' : ''}>
          <h2 className="font-display font-semibold text-gray-900">{organizationName}</h2>
          <p className="text-xs text-gray-500">Gerenciar empresa</p>
        </div>
        <ChevronDown className={`w-4 h-4 ml-auto text-gray-400 transition-transform ${isCollapsed ? 'hidden' : ''} ${
          isMenuOpen ? 'rotate-180' : ''
        }`} />
      </div>

      <CompanyMenu 
        isOpen={isMenuOpen} 
        onClose={() => setIsMenuOpen(false)}
        setActiveSection={setActiveSection}
      />
    </div>
  );
}

export default CompanyHeader;